<template>
    <section class="text-base">
        <PageHeader>
            <h1>{{ $t("Global.SignInLabel") }}</h1>
        </PageHeader>
        <div class="container">
            <LoginForm class="my-8 max-w-md" @complete="onComplete" />
        </div>
    </section>
</template>
<script setup lang="ts">
const { t } = useI18n();

useSeoMeta({
    title: t("SignIn.PageTitle"),
    ogTitle: t("SignIn.PageTitle"),
    description: t("SignIn.MetaDescription"),
    ogDescription: t("SignIn.MetaDescription"),
});

async function onComplete(response: LogInResponse) {
    navigateTo(response.ReturnUrl || "/", { external: true });
}
</script>
